/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Divider, Typography, makeStyles, useTheme } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { Link } from 'react-router-dom';
import { useLinkStyles } from 'components/common/useLinkStyles';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { LanguageDirection } from '../../../shared/enums/LanguageDirection';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    margin: '.5rem .7rem 0 .7rem',
    textDecorationColor: theme.palette.primary.main,
    '&:hover': {
      textDecorationColor: theme.palette.primary.main,
    },
  },
  divider: {
    margin: '.5rem 0 0',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  header: {
    justifyContent: 'space-between',
    padding: '.7rem',
    '& p, svg': {
      color: theme.palette.primary.main,
    },
    ' & p': {
      fontWeight: 600,
      fontSize: '1.25rem',
      [theme.breakpoints.up('xl2')]: {
        fontSize: '1.375rem',
      },
    },
  },
  rtlIcon: {
    transform: 'scaleX(-1)',
  },
}));

export function DashboardCardHeader({ label, navigationUrl }) {
  const classes = useStyles();
  const linkClass = useLinkStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isRTL = theme.direction === LanguageDirection.RTL;

  return (
    <Link id={`${label}-header`} className={`${classes.root} ${linkClass.link}`} to={navigationUrl} aria-label={label}>
      <div className={classNames(classes.textContainer, classes.header)}>
        <Typography>{`${t(label)}`}</Typography>
        <ChevronRight className={classNames({ [classes.rtlIcon]: isRTL })} />
      </div>
      <Divider className={classes.divider} />
    </Link>
  );
}
